import { Flex, Text } from '@cmpsr/components';

type EarlyAccessHeaderProps = {
  email?: string;
  variant?: 'above' | 'below';
};

export default function EarlyAccessHeader({ email, variant = 'below' }: EarlyAccessHeaderProps) {
  return (
    <Flex flexDir="column" gap="spacer-2" justifyContent="center" alignItems="center">
      <Text variant="text-header-XL" textAlign="center">
        Thanks for your interest in joining Catch. You've been added to our{' '}
        <Text as="span" textStyle="text-header-xl-v">
          waitlist
        </Text>
      </Text>
      <Text variant="text-body-regular" textAlign="center">
        We are excited to help you take control of your health.
      </Text>
      <Text variant="text-body-regular" textAlign="center">
        If you have an invite code, please enter it {variant === 'above' ? 'above' : 'below'}. Otherwise, we will send
        you an invitation via email as soon as possible to{' '}
        <Text as="span" textStyle="text-body-bold" color="text-secondary">
          {email}
        </Text>
      </Text>
    </Flex>
  );
}
